import { useState } from "react";
import { LockOpen } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "@/components/ui/alert-dialog";

export const UnlockDoorButton = ({ bookingId, label = "Unlock door now", compact, testid = "unlock-door-btn" }) => {
  const [busy, setBusy] = useState(false);
  const unlock = async () => {
    setBusy(true);
    try { await api.post("/admin/tuya/unlock", { booking_id: bookingId || null }); toast.success("Door unlocked"); }
    catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <button disabled={busy} data-testid={testid}
          className={compact ? "text-xs flex items-center gap-1 text-white/50 hover:text-[#D4AF37] disabled:opacity-40"
            : "btn-gold rounded-full px-4 py-2 text-xs font-mono-label uppercase flex items-center gap-1.5 disabled:opacity-50"}>
          <LockOpen size={compact ? 12 : 14} className={busy ? "animate-pulse" : ""} /> {busy ? "Unlocking…" : label}
        </button>
      </AlertDialogTrigger>
      <AlertDialogContent className="bg-[#111] border-white/10" data-testid={`${testid}-dialog`}>
        <AlertDialogHeader>
          <AlertDialogTitle className="text-white">Unlock the studio door?</AlertDialogTitle>
          <AlertDialogDescription className="text-white/50">The lock will open remotely right now. Make sure someone you trust is at the door.</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid={`${testid}-cancel`}>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={unlock} data-testid={`${testid}-confirm`} className="bg-[#D4AF37] text-black hover:bg-[#c9a432]">Unlock</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
